const createSlotZPL = (row, col, pos, slot) => {
  const width = 332
  const height = 332
  const startX = 440
  const startY = 250
  const gap = 10
  const unitW = (width - (col - 1) * gap) / col
  const unitH = (height - (row - 1) * gap) / row
  const grids = []
  for (let i = 0; i < row; i++) {
    for (let j = 0; j < col; j++) {
      if (i === pos[0] && j === pos[1]) {
        grids.push(
          `^FO${startX + j * unitW + j * gap},${
            startY + i * unitH + i * gap
          }^GB${unitW},${unitH},${Math.min(unitW, unitH)}^FS`
        )
      } else {
        grids.push(
          `^FO${startX + j * unitW + j * gap},${
            startY + i * unitH + i * gap
          }^GB${unitW},${unitH},3,B,0^FS`
        )
      }
    }
  }
  const zpl =
    '^XA ^FO0,50^A0N,200,200^FB812,1,0,C^FD' +
    slot.no +
    '\\&^FS ^FO36,240 ^BQN,2,10 ^FDMA,{"id": "' +
    slot.id +
    '","no": "' +
    slot.no +
    '","type": "Slot"}^FS ^FO508,215^A0N,30,30^FDLeft^FS ^FO598,215^GFA,104,104,4,,:::I018,I03C,I01E,J0F,J078,J03C,J01E,LF,LFC,:LF,J01E,J03C,J078,J0F,I01E,I03C,I018,,:::^FS ^FO648,215^A0N,30,30^FDRight^FS ' +
    grids.join(' ') +
    '^XZ'
  return zpl
}
export const createStackZPLs = stack => {
  const res = []
  const no = stack.no
  const slots = Object.fromEntries(stack.slots.map(one => [one.no, one]))
  for (let i = 0; i < stack.sectionNum; i++) {
    for (let j = 0; j < stack.slotPerSection; j++) {
      const slotNo = no + '0' + (i + 1) + String.fromCharCode(65 + j)
      const slot = slots[slotNo]
      const zpl = createSlotZPL(
        stack.sectionNum,
        stack.slotPerSection,
        [i, j],
        slot
      )
      res.push(zpl)
    }
  }
  return res
}

export const zplPdf = async zpl => {
  const myHeaders = new Headers()
  myHeaders.append('Accept', 'application/pdf')

  const formdata = new FormData()
  formdata.append('file', zpl)

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: formdata,
    redirect: 'follow'
  }

  const res = await fetch(
    'http://api.labelary.com/v1/printers/8dpmm/labels/4x3/',
    requestOptions
  )
  const blob = await res.clone().blob()
  return blob
}
